// @ts-nocheck
import { Button, Input, Popconfirm, message, Checkbox } from "antd";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import API_HOST from "../config.js";
import SelectAccounts from "./selectAccounts.js";
import { testProfile } from "./cancelFunction.js";
const { TextArea } = Input;

function LinkAccounts(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile); // Accounts profile
  const [faKey, setFAKey] = useState('');
  const [mccFaKey, setMccFAKey] = useState('');
  const [mccProfileModel, setMCCProfileModel] = useState(); //mcc profile
  const [mccProfileId, setMCCProfileId] = useState(); //mcc profile ID

  const [mccId, setMccId] = useState("");
  const [mccList, setMccList] = useState([]);
  const [remove, setRemove] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const link = async (profile) => {
    messageApi.info(`Profile: ${profile.name} >>> Link TK >>> MCC: ${mccProfileModel?.data?.name}...`);
    let body = {
      profile: profile,
      faKey: faKey,
      remove,
      toProfile: {
        profileId: mccProfileId,
        profileName: mccProfileModel?.data?.name,
        mccId: mccList?.length > 0 ? mccList[0] : mccId,
        mccFaKey 
      }
    };
    axios
      .post(`${API_HOST}/api/link-accounts`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ link-accounts ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  useEffect(() => {
    if (mccProfileId) {
      getProfileById(mccProfileId, (profile) => {
        setLoading(false);
        setMCCProfileModel(profile);
      });
      let mccFAKey = localStorage.getItem(`fakey-${mccProfileId}`);
      if(mccFAKey) {
        setMccFAKey(mccFAKey)
      }
    }
  }, [mccProfileId]);

  const getProfileById = async (id, then) => {
    setLoading(true);
    axios
      .get(`${API_HOST}/api/profiles/${id}`)
      .then((res) => {
        if (res.data) {
          then(res.data[0]);
        }
      })
      .catch((e) => {
        setLoading(false);
        // messageApi.error("Không thể lấy thông tin Profile");
      });
  }

  const onOpenChange = (open) => {
    if (open) {
      getProfileById(props.profile.id, (profile) => {
        setLoading(false);
          setProfileModel(profile);
          setFAKey(profile.faKey);
      })
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText={(!mccProfileId || mccList?.length <= 0) ? "Hãy Chọn MCC" : "Xác nhận"}
        cancelText="Hủy"
        title="Xác nhận: Link TK"
        description={
          <>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <div style={{padding: 10, borderRadius: 6, border: "1px solid green"}}>
              <label>Chuyển TKCN từ: <strong>{props.profile.name}</strong></label>
              <br/>
              <br/>
              <label>2FA Key:</label>
              <br/>
              <Input
                style={{ width: 250 }}
                value={faKey}
                placeholder="2FA Key ..."
                onChange={(e) => setFAKey(e.target.value)}
              />
              <br/>
              <br/>
              <Checkbox checked={remove} onChange={e => setRemove(e.target.checked)}>
                Xóa TK Sau Khi Link
              </Checkbox>
              <br />
            </div>

            <br />
            <label>Sang MCC:</label>
            <br />
            <div style={{padding: 10, borderRadius: 6, border: "1px solid red"}}>
              <label>Profile ID: </label>
              <Input
                style={{ width: 150 }}
                placeholder="Điền Profile ID của MCC ..."
                onChange={(e) => setMCCProfileId(e.target.value)}
              />
              <br />
              <label>2FA Key:</label>
              <br/>
              <Input
                style={{ width: 250 }}
                value={mccFaKey}
                placeholder="2FA Key  MCC..."
                onChange={(e) => {
                  setMccFAKey(e.target.value);
                  localStorage.setItem(`fakey-${mccProfileId}`, e.target.value)
                }}
              />
              <br/>
              <br />
              {mccProfileModel && <>
                <lable>Tên Profile: <strong>{mccProfileModel?.data?.name}</strong></lable><br />
                <label>Nhập MCC ID (Nếu có nhiều TK MCC):</label>
                <br />
                <Input
                  style={{ width: 300 }}
                  placeholder="MCC ID"
                  onChange={(e) => setMccId(e.target.value)}
                />
                <br />
                <label>Hoặc: </label>
                <SelectAccounts selectAccounts={mccProfileModel?.selectAccounts} max={1}
                  onSelected={(selected) => setMccList(selected)}
                />
                <br />
              </>}
            </div>

          </>
        }
        onConfirm={() => link(props.profile)}
      >
        <Button type="primary" 
          loading={loading}>
          Link TK
        </Button>
      </Popconfirm>
    </>
  );
}
export default LinkAccounts;
